import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-8" }
const _hoisted_2 = { class: "col-xxl-4" }
const _hoisted_3 = { class: "col-xxl-4" }
const _hoisted_4 = { class: "col-xxl-4" }
const _hoisted_5 = { class: "row gy-5 gx-xl-8" }
const _hoisted_6 = { class: "col-xxl-4" }
const _hoisted_7 = { class: "col-xxl-8" }
const _hoisted_8 = { class: "row gy-5 g-xl-8" }
const _hoisted_9 = { class: "col-xxl-4" }
const _hoisted_10 = { class: "col-xxl-4" }
const _hoisted_11 = { class: "col-xxl-4" }
const _hoisted_12 = { class: "row g-5 gx-xxl-8" }
const _hoisted_13 = { class: "col-xxl-4" }
const _hoisted_14 = { class: "col-xxl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MixedWidget2 = _resolveComponent("MixedWidget2")!
  const _component_ListWidget5 = _resolveComponent("ListWidget5")!
  const _component_MixedWidget7 = _resolveComponent("MixedWidget7")!
  const _component_MixedWidget10 = _resolveComponent("MixedWidget10")!
  const _component_ListWidget3 = _resolveComponent("ListWidget3")!
  const _component_TableWidget9 = _resolveComponent("TableWidget9")!
  const _component_ListWidget2 = _resolveComponent("ListWidget2")!
  const _component_ListWidget6 = _resolveComponent("ListWidget6")!
  const _component_ListWidget1 = _resolveComponent("ListWidget1")!
  const _component_MixedWidget5 = _resolveComponent("MixedWidget5")!
  const _component_TableWidget5 = _resolveComponent("TableWidget5")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_MixedWidget2, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "widget-color": "danger",
          "chart-height": "200",
          "stroke-color": "#cb1e46"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ListWidget5, { "widget-classes": "card-xxl-stretch mb-5 mb-xl-10" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_MixedWidget7, {
          "widget-classes": "card-xxl-stretch-50 mb-5 mb-xl-8",
          "chart-color": "primary",
          "chart-height": "150"
        }),
        _createVNode(_component_MixedWidget10, {
          "widget-classes": "card-xxl-stretch-50 mb-5 mb-xl-8",
          "chart-color": "primary",
          "chart-height": "168"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ListWidget3, { "widget-classes": "card-xxl-stretch mb-xl-3" })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TableWidget9, { "widget-classes": "card-xxl-stretch mb-5 mb-xl-8" })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ListWidget2, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_ListWidget6, { "widget-classes": "card-xl-stretch mb-xl-8" })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_ListWidget1, { "widget-classes": "card-xxl-stretch mb-xl-3" })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_MixedWidget5, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "chart-color": "success",
          "chart-height": "150"
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_TableWidget5, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
      ])
    ])
  ], 64))
}